/**
 * Currently on AWS for SSR the host in the headers is set to
 * `sportfondsen-website-tst-client.s3.eu-west-1.amazonaws.com`
 * where we expect it to be
 * `sportfondsen.tst.sportfondsen-website.lukkien.com`
 *
 */

import { gql } from 'graphql-request';

export default gql`
  query pages {
    pages {
      id
      url
      contentType
    }
  }
`;
